import * as React from 'react'

interface IProps {
  children?: React.ReactNode
  onEnter?: () => void
  onLeave?: () => void
  id?: string
}

const OnLifecycle = (props: IProps) => {
  React.useEffect(() => {
    if (props.onEnter) {
      props.onEnter()
    }
    return () => {
      if (props.onLeave) {
        props.onLeave()
      }
    }
  }, [props.id])
  return <>{props.children}</>
}

export default OnLifecycle
